import { css } from 'twin.macro';
import { Button, FormLabel, InputGroup, Nav } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { fetchWrapper, getTeamIdFromURL, toastWrapper, getChannelIdFromSettingsURL } from '../../../../../_helpers';
import { connect } from 'react-redux';
import { ActionStyles } from '../../../../Admin/reusableStyles';

//assets
import { VscLoading } from 'react-icons/vsc';
import FormSvg from '../../../../../assets/forms.svg';
import SortedTableHeaderIcon from '../../../../Admin/SortedTableHeaderIcon';
import Pagination from '../../../../Admin/Pagination';
import { FormPackageTable } from '../TeamSettingFormPackage';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { ToolTip } from '@/_elements/ToolTip';
import { BsPencil } from 'react-icons/bs';

const FormGroupTable = ({ search, teamRooms, channel }) => {
    const [visitTemplates, setVisitTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const teamId = getTeamIdFromURL();
    const channelIdFromUrl = getChannelIdFromSettingsURL();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalResults, setTotalResults] = useState(10);
    const [sortBy, setSortBy] = useState({
        key: 'createdAt',
        direction: 'desc',
    });

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const res = await fetchWrapper.get(
                    `form-groups?page=${currentPage}&limit=10${channel || channelIdFromUrl ? `&chatroom=${channel?.value || channel?._id || channelIdFromUrl}` : ''}&team=${teamId}`
                );
                setVisitTemplates(res.results);
                setTotalResults(res.totalResults);
            } catch (error) {
                console.log('ERROR => ', error);
                toastWrapper.error(error?.message);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [teamId, sortBy, search, currentPage, channel]);

    const handleSort = (fieldName) => {
        setSortBy({ direction: sortBy.direction === 'asc' ? 'desc' : 'asc', key: fieldName });
    };

    return (
        <div>
            {loading ? (
                <h4 className="text-center">
                    <VscLoading className="spin" fontSize="42" />
                </h4>
            ) : visitTemplates?.length > 0 ? (
                <div className="custom-card">
                    <FormPackageTable className="w-100">
                        <thead>
                            <tr>
                                <th
                                    onClick={() => handleSort('createdAt')}
                                    css={css`
                                        color: inherit;
                                        cursor: pointer;
                                    `}
                                >
                                    S.N
                                    <SortedTableHeaderIcon sortConfig={sortBy} fieldName={'createdAt'} />
                                </th>
                                <th>Form Group Name</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visitTemplates?.map((templateData, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{10 * (currentPage - 1) + index + 1}</td>
                                        <td
                                            className="d-flex align-items-center"
                                            css={css`
                                                flex: 1;
                                            `}
                                        >
                                            <div
                                                css={css`
                                                    display: flex;
                                                    flex-direction: column;
                                                    gap: 0.5rem;
                                                `}
                                            >
                                                <div
                                                    css={css`
                                                        display: flex;
                                                        flex-direction: row;
                                                    `}
                                                >
                                                    <span
                                                        css={css`
                                                            white-space: nowrap;
                                                            overflow: hidden;
                                                            text-overflow: ellipsis;
                                                            max-width: 50rem;
                                                        `}
                                                    >
                                                        {templateData?.name}
                                                    </span>
                                                    {templateData?.archived ? (
                                                        <span className="badge badge-danger mx-2">Archived</span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <td>{dayjs(templateData?.createdAt).format('MMMM D, YYYY h:mm A')}</td>
                                        </td>
                                        <td>
                                            <ActionStyles className="mt-2">
                                                <Link to={`/form-group-library/edit/${templateData._id}`}>
                                                    <ToolTip
                                                        text={'Edit'}
                                                        side={'top'}
                                                        cssStyles={
                                                            'top:-70% !important; min-width: fit-content !important'
                                                        }
                                                    >
                                                        <BsPencil className="icon edit" />
                                                    </ToolTip>
                                                </Link>
                                            </ActionStyles>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </FormPackageTable>
                </div>
            ) : (
                <div
                    css={css`
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                    `}
                >
                    <img
                        src={FormSvg}
                        alt={'no data found'}
                        css={css`
                            width: 350px;
                            margin: 1rem 0;
                        `}
                    />
                    <h2 className="text-center">No Data</h2>
                </div>
            )}
            <div className="p-4">
                <Pagination
                    totalRecords={totalResults}
                    key={totalResults}
                    pageLimit={10}
                    pageNeighbours={1}
                    onPageChanged={(data) => {
                        setCurrentPage(Math.max(1, data.currentPage));
                    }}
                />
            </div>
        </div>
    );
};
const mapStateToProps = (state) => ({
    teamRooms: state.rooms.teamRooms,
});

export default connect(mapStateToProps, {})(FormGroupTable);
